import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('UserProfileInput')
export class UserProfile {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('upro') })
  _id?: string

  @Field(() => String)
  @Prop({ type: String, index: true })
  email: string

  @Field(() => String)
  @Prop({ type: String, index: true })
  name: string //this is similar to the fullname

  @Field(() => String)
  @Prop({ type: String, index: true })
  lastName?: string

  @Field(() => String)
  @Prop({ type: String })
  firstName?: string

  @Field(() => String)
  @Prop({ type: String })
  middleName?: string

  @Field(() => String)
  @Prop({ type: String })
  otherName?: string

  @Field(() => String)
  @Prop({ type: String })
  picture: string
}
